import React from 'react'
import "./css/AdminProduct.css";
import { Link } from 'react-router-dom';
import { DeleteForever, Edit } from '@mui/icons-material';

function AdminProduct({ data }) {
  return (
    <div className='admin-product'>
        <Link to={`/product-detail/${data?.productName}`}>
        <img src={data?.productImage[0]} alt={data?.productName} />
      <div className="product_info">
        <p>{data?.productName}</p>
        <div className="product_price">
          <p>${data?.productPrice}</p>
        </div>
      </div>
      </Link>{/*
        <div className='button-group'>
            <button> <Edit /> Edit </button>
            <button> <DeleteForever /> Delete </button>
  </div>*/}
    </div>
  )
}

export default AdminProduct